<template>
  <v-card max-width="500" class="mx-auto elevation-0" color="transparent">
    <v-card-title
      class="justify-center"
    >
      <v-img
        :src="require('@/assets/undraw_personal_information_962o.svg')"
        height="100"
        contain
      ></v-img>
      Informations générales
    </v-card-title>

    <v-form ref="form" @submit.prevent>
      <v-expansion-panels v-model="activePanelIndex" :readonly="isSaving">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">
                  Nom et prénom
                </v-col>
                <v-col
                  cols="8"
                  class="text--secondary"
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      Modifier votre nom et prénom
                    </span>
                    <span
                      v-else
                      key="1"
                    >
                      {{ user.firstName }} {{ user.lastName }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Prénom"
                  v-model="firstName"
                  :rules="rules.firstName"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Nom"
                  v-model="lastName"
                  :rules="rules.lastName"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ nom: lastName, prenom: firstName })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Date de naissance
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifier votre date de naissance
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.birthDate | formatDate }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-menu
                  ref="birthMenu"
                  v-model="birthMenuIsActive"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Date de naissance"
                      :value="birthDate | formatDate"
                      :rules="rules.birthDate"
                      filled
                      readonly
                      :disabled="isSaving"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    ref="birthPicker"
                    v-model="birthDate"
                    :max="new Date(new Date().setFullYear(
                      new Date().getFullYear() - 18)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="saveBirth"
                    no-title
                    first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ date_naissance: birthDate })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Sexe
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifier votre sexe
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.gender }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-radio-group
                  label="Sexe"
                  v-model="gender"
                  mandatory
                  row
                  :disabled="isSaving"
                >
                  <v-radio
                    label="Homme"
                    value="M"
                  >
                  </v-radio>

                  <v-radio
                    label="Femme"
                    value="F"
                  >
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ genre: gender })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Nationalité
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifier votre nationalité
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.nationality }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-autocomplete
                  label="Nationalité"
                  v-model="nationality"
                  :items="nationalities"
                  :rules="rules.nationality"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ nationalite: nationality })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Mot de passe
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifier votre mot de passe
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    ********
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Nouveau mot de passe"
                  v-model="password"
                  :rules="compPassRules"
                  validate-on-blur
                  :append-icon="passIsVisible ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="passIsVisible ? 'text' : 'password'"
                  @click:append="passIsVisible = !passIsVisible"
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Confirmer"
                  v-model="confirmPassword"
                  :rules="compConfPassRules"
                  validate-on-blur
                  :append-icon="passIsVisible ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="passIsVisible ? 'text' : 'password'"
                  @click:append="passIsVisible = !passIsVisible"
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ candidat : { password, password_confirmation: confirmPassword } })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rulesMixin from '@/mixins/rulesMixin';

export default {
  name: 'ProfileInfos',

  mixins: [rulesMixin],

  props: {
    countries: Array,
  },

  data: () => ({
    birthMenuIsActive: false,
    firstName: '',
    lastName: '',
    birthDate: '',
    gender: '',
    nationality: '',
    password: '',
    confirmPassword: '',
    passIsVisible: false,
    activePanelIndex: undefined,
    isSaving: false,
  }),

  computed: {
    ...mapState(['user']),

    compPassRules() {
      return this.activePanelIndex === 4 ? this.rules.password : [];
    },

    compConfPassRules() {
      return this.activePanelIndex === 4 ? this.rules.confirmPassword : [];
    },
    nationalities() {
      const data = this.countries.map((item) => item.nationality);
      return data.sort((a, b) => a.localeCompare(b));
    },
  },

  methods: {
    ...mapActions(['updateUserData']),

    close() {
      this.activePanelIndex = undefined;
    },

    modify(data) {
      if (!this.$refs.form.validate()) return;
      this.isSaving = true;
      this.updateUserData(data)
        .then(() => {
          this.close();
        })
        .catch(() => {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Erreur lors de la modification du profil',
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    saveBirth(date) {
      this.$refs.birthMenu.save(date);
    },
  },

  watch: {
    activePanelIndex() {
      this.firstName = this.user.firstName;
      this.lastName = this.user.lastName;
      this.birthDate = this.user.birthDate;
      this.gender = this.user.gender;
      this.nationality = this.user.nationality;
      this.password = '';
      this.confirmPassword = '';
      this.$refs.form.resetValidation();
    },
    birthMenuIsActive(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.birthPicker.activePicker = 'YEAR';
        });
      }
    },
  },
};
</script>
